import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {Storage} from "@ionic/storage";
import {Poi} from "../../classes/common/poi";

@Injectable({
  providedIn: 'root'
})

export class GoogleMapsService {

  static google: any;

  divMap: any;
  map: any;
  currentMap: string;
  markers_in_spider: any[];

  private trafficLayer: any;

  private listeners: any = {};
  private circles: any = {};
  private markers: any = {};
  private polylines: any = {};
  private popups: any = {};
  marker_opts: {marker_size: number, label_size: number, margin_size: number, label_number_size: number} = {
    marker_size: 4,
    label_size: 4,
    margin_size: 2,
    label_number_size: 2
  }


  private mainMapChangeEnabled: any = true;

  onMapClosed = new Subject<any>();
  onMapClosed$ = this.onMapClosed.asObservable();

  static googleReady = new Subject<any>();
  static googleReady$ = GoogleMapsService.googleReady.asObservable();

  constructor(
    private storage: Storage
  ) {
  }

  initialization(google: any, isMobile?: boolean){
    console.log('inizializza google maps');
    if(isMobile){
      this.marker_opts = {
        marker_size: 2,
        label_size: 2,
        margin_size: 1,
        label_number_size: 2
      }
    }
    this.storage.get('markerOpts').then((marker_opts: any) => {
      if(marker_opts){
        this.marker_opts = {
          ...this.marker_opts,
          ...marker_opts
        };
      }
      this.createMarkerCss();
    });
    GoogleMapsService.google = google;
    GoogleMapsService.googleReady.next(undefined);
  }

  createMarkerCss(force_reload?: boolean){
    const max_width_container: number = 200;

    const size_marker: number = 25 + ((this.marker_opts.marker_size || 4 - 1) * 9);
    const label_string_font: number = 9 + ((this.marker_opts.marker_size || 4 - 1) * 2);
    const heading_size: number = 12 + ((this.marker_opts.marker_size || 4 - 1) * 3);
    const font_label: number = 8 + ((this.marker_opts.label_size || 4 - 1) * 2);
    const font_label_number: number = 8 + ((this.marker_opts.label_number_size || 2 - 1) * 1.4);
    const v_border: number = 4 + ((this.marker_opts.marker_size || 4 - 1) * 0.33);
    const margin_size: number = 10 + ((this.marker_opts.margin_size || 1 - 1) * 2);

    if (!document.getElementById("custom-marker-style") || force_reload) {

      console.log('rimetto css')
      const style = document.createElement("style");
      style.id = "custom-marker-style";
      style.textContent = `

.mappa_custom-marker {
  padding-bottom: 12px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.mappa_label_number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: ${label_string_font}px;
  font-weight: bold;
  z-index: 2;
  pointer-events: none;
  font-family: sans-serif;
}

.mappa_marker-label {
  background: white;
  color: #333;
  font-size: ${font_label}px;
  padding: 4px 8px;
  border-radius: 12px;
  border: 1px solid #ccc;
  margin-bottom: 0px;
  font-family: sans-serif;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  z-index: 5;
  max-width: ${max_width_container}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.mappa_marker {
  width: ${size_marker}px;
  height: ${size_marker}px;
  background-color: grey;
  border: 2px solid white;
  border-radius: 50%;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mappa_marker-quadrato {
  border-radius: 8px;
  background: #6c7acb;
}

.mappa_internal_img{
  width: ${size_marker - margin_size}px;
  height: ${size_marker - margin_size}px;
  border-radius: 50%;
  background-color: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 3;
}

.mappa_internal_img_quadrata{
  border-radius: 0;
}

.mappa_v-marker-border {
  position: absolute;
  bottom: -14px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: ${v_border + 2}px solid transparent;
  border-right: ${v_border + 2}px solid transparent;
  border-top: 14px solid white;
  z-index: 0;
}

.mappa_v-marker {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: ${v_border}px solid transparent;
  border-right: ${v_border}px solid transparent;
  border-top: 12px solid #6c7acb;
  z-index: 1;
}

.mappa_din1_state {
  position: absolute;
  top: -2px;
  left: -8px;
  width: ${heading_size}px;
  height: ${heading_size}px;
  background-color: yellow;
  border-radius: 50%;
  border: 1px solid #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  display: none;
  z-index: 4;
}

.mappa_arrow-icon {
  position: absolute;
  top: -2px;
  right: -8px;
  width: ${heading_size}px;
  height: ${heading_size}px;
  background-color: white;
  border-radius: 50%;
  border: 1px solid #aaa;
  display: flex;
  // align-items: center;
  justify-content: center;
  padding: 2px;
  z-index: 4;
}

.mappa_etichetta_number{
  position: absolute;
  color: #000 !important;
  bottom: -5px;
  right: -7px;
  min-width: 25px;
  text-align: center;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 2px;
  font-size: ${font_label_number}px;
  z-index: 4;
  display: none;
}`;
      document.head.appendChild(style);
    }
  }

  isReady(){
    return new Promise((resolve) => {
      if(GoogleMapsService.google) return resolve(null)
      let sub: any = GoogleMapsService.googleReady$.subscribe(async () => {
        sub.unsubscribe();
        return resolve(null)
      });
    });
  }

  getMap(){
    if(!this.map) {
      this.divMap = document.createElement("div");
      this.divMap.style.width = "100%";
      this.divMap.style.height = "100%";
      this.map = new GoogleMapsService.google.maps.Map(this.divMap, {
        center: {lat: 41.8897, lng: 12.4935},
        zoom: 7,
        fullscreenControl: false,
        zoomControlOptions: {
          position: GoogleMapsService.google.maps.ControlPosition.LEFT_BOTTOM
        },
        streetViewControl: false,
        streetViewControlOptions: {
          position: GoogleMapsService.google.maps.ControlPosition.LEFT_BOTTOM
        },
        mapTypeControl: false,
        mapId: "Witek-map"
      });
    }
    return this.map;
  }

  getDivMap(){
    return this.divMap;
  }

  setCurrentMap(currentMap: string){
    this.currentMap = currentMap;
  }


  addPolyline(polyline: any, map: string){
    let polylineId: string = polyline.get("id");
    if(!polylineId) return console.error("No polylineId _id, polyline not added in map");
    if(!this.polylines.hasOwnProperty(map)){
      this.polylines[map] = {};
    }
    if(this.polylines[map][polylineId]) this.polylines[map][polylineId].setMap(null);
    this.polylines[map][polylineId] = polyline;
    polyline.setMap(this.map);
  }

  removePolyline(polyline: any, map: string){
    let polylineId: string = polyline.get("id");
    if(!polylineId) return console.error("No polyline _id, polyline not removed in map");
    if(!this.polylines.hasOwnProperty(map)){
      this.polylines[map] = {};
    }
    if(this.polylines[map].hasOwnProperty(polylineId)){
      delete this.polylines[map][polylineId];
    }
    polyline.setMap(null);
  }

  addPopup(popup: any, map: string){
    let popupId: string = popup.id;
    if(!popupId) return console.error("No popup id, popup not added in map");
    if(!this.popups.hasOwnProperty(map)){
      this.popups[map] = {};
    }
    if(this.popups[map][popupId]) this.popups[map][popupId].setMap(null);
    this.popups[map][popupId] = popup;
    popup.setMap(this.map);
  }

  removePopup(popup: any, map: string){
    let popupId: string = popup.id;
    if(!popupId) return console.error("No popup id, popup not remove in map");
    if(!this.popups.hasOwnProperty(map)){
      this.popups[map] = {};
    }
    if(this.popups[map].hasOwnProperty(popupId)){
      delete this.popups[map][popupId];
    }
    popup.setMap(null);
  }




  addCircle(circle: any, map: string){
    let circleId: string = circle.get("id");
    if(!circleId) return console.error("No circle _id, circle not added in map");
    if(!this.circles.hasOwnProperty(map)){
      this.circles[map] = {};
    }
    if(this.circles[map][circleId]) this.circles[map][circleId].setMap(null);
    this.circles[map][circleId] = circle;
    if(this.getMainMapUpdateState() || map !== "main"){
      circle.setMap(this.map);
    }
  }

  removeCircle(circle: any, map: string){
    let circleId: string = circle.get("id");
    if(!circleId) return console.error("No circle _id, circle not removed in map");
    if(!this.circles.hasOwnProperty(map)){
      this.circles[map] = {};
    }
    if(this.circles[map].hasOwnProperty(circleId)){
      delete this.circles[map][circleId];
    }
    circle.setMap(null);
  }

  addMarker(marker: any, map: string){
    let markerId: string = marker.id;
    if(!markerId) return console.error("No marker _id, marker not added in map", markerId);
    if(!this.markers.hasOwnProperty(map)){
      this.markers[map] = {};
    }
    if(this.markers[map][markerId]) this.markers[map][markerId].map = null;
    this.markers[map][markerId] = marker;
  }

  getMainMapUpdateState(){
    return this.mainMapChangeEnabled;
  }

  emitCloseMap(){
    this.onMapClosed.next(undefined);
  }

  addListener(listenerRef: any, map: string){
    if(!this.listeners.hasOwnProperty(map)){
      this.listeners[map] = [];
    }
    this.listeners[map].push(listenerRef);
  }


  removeListeners(map?: string){
    if(!map){
      for(let key in this.listeners){
        if(Array.isArray(this.listeners[key])){
          for(let listener of this.listeners[key]){
            GoogleMapsService.google.maps.event.removeListener(listener);
          }
          this.listeners[key] = [];
        }
      }
    }else{
      if(this.listeners[map] && Array.isArray(this.listeners[map])){
        for(let listener of this.listeners[map]){
          GoogleMapsService.google.maps.event.removeListener(listener);
        }
        this.listeners[map] = [];
      }
    }
  }

  removeCircles(map?: string){
    if(!map){
      for(let key in this.circles){
        if(this.circles[key]){
          for(let circleId in this.circles[key]){
            this.circles[key][circleId].setMap(null);
          }
        }
      }
    }else{
      if(this.circles[map]){
        for(let circleId in this.circles[map]){
          this.circles[map][circleId].setMap(null);
        }
      }
    }
  }

  removeMarkers(map?: string){
    if(!map){
      for(let key in this.markers){
        if(this.markers[key]){
          for(let markerId in this.markers[key]){
            this.markers[key][markerId].map = null;
          }
        }
      }
    }else{
      if(this.markers[map]){
        for(let markerId in this.markers[map]){
          this.markers[map][markerId].map = null;
        }
      }
    }
  }

  removePolylines(map?: string){
    if(!map){
      for(let key in this.polylines){
        if(this.polylines[key]){
          for(let polylineId in this.polylines[key]){
            this.polylines[key][polylineId].setMap(null);
          }
        }
      }
    }else{
      if(this.polylines[map]){
        for(let polylineId in this.polylines[map]){
          this.polylines[map][polylineId].setMap(null);
        }
      }
    }
  }

  removePopups(map?: string){
    if(!map){
      for(let key in this.popups){
        if(this.popups[key]){
          for(let popupId in this.popups[key]){
            this.popups[key][popupId].setMap(null);
          }
        }
      }
    }else{
      if(this.popups[map]){
        for(let popupId in this.popups[map]){
          this.popups[map][popupId].setMap(null);
        }
      }
    }
  }

  clearMap(){
    this.disableInfoTraffic();
    this.removeListeners();
    this.removeCircles();
    this.removeMarkers();
    this.removePolylines();
    this.removePopups();
    this.removeUIControls();
    if(this.map){
      this.map.setMapTypeId(GoogleMapsService.google.maps.MapTypeId.ROADMAP);
      let streetView = this.map.getStreetView();
      if(streetView) streetView.setVisible(false);
    }
    this.listeners = {};
    this.circles = {};
    this.markers = {};
    this.polylines = {};
    this.popups = {};
  }

  enableInfoTraffic(){
    if(!this.trafficLayer){
      this.trafficLayer = new GoogleMapsService.google.maps.TrafficLayer();
    }
    this.trafficLayer.setMap(this.map);
  }

  disableInfoTraffic(){
    if(this.trafficLayer) this.trafficLayer.setMap(null);
  }

  removeUIControls(){
    if(this.map){
      for(let control of this.map.controls){
        if(control !== undefined){
          try{
            control.clear();
          }catch(err){
            console.error(err);
          }
        }
      }
      this.map.setOptions({
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      });
    }
  }

  removeMarker(marker: any, map: string){
    let markerId: string = marker.id;
    if(!markerId) return console.error("No marker _id, marker not removed in map");
    if(!this.markers.hasOwnProperty(map)){
      this.markers[map] = {};
    }
    if(this.markers[map].hasOwnProperty(markerId)){
      delete this.markers[map][markerId];
    }
    marker.map = null;
  }


  createSelectedMarker() {
    const container = document.createElement("div");
    container.style.position = "relative";
    container.style.display = "flex";
    container.style.flexDirection = "column";
    container.style.alignItems = "center";
    container.style.justifyContent = "center";

    // Cerchio principale (testa del marker)
    const circle = document.createElement("div");
    circle.style.width = "30px";
    circle.style.height = "30px";
    circle.style.backgroundColor = "#4285F4";
    circle.style.border = "2px solid white";
    circle.style.borderRadius = "50%";
    circle.style.boxShadow = "0 0 6px rgba(0,0,0,0.3)";
    circle.style.display = "flex";
    circle.style.alignItems = "center";
    circle.style.justifyContent = "center";
    circle.style.color = "white";
    circle.style.fontWeight = "bold";
    circle.style.fontSize = "14px";
    circle.textContent = ""; // se vuoi mettere un numero o una lettera

    // Punta a V sotto al cerchio
    const triangle = document.createElement("div");
    triangle.style.width = "0";
    triangle.style.height = "0";
    triangle.style.position = "absolute";
    triangle.style.bottom = "-6px";
    triangle.style.borderLeft = "6px solid transparent";
    triangle.style.borderRight = "6px solid transparent";
    triangle.style.borderTop = "10px solid #4285F4"; // stesso colore del cerchio
    triangle.style.marginTop = "-2px"; // per avvicinarla al cerchio
    triangle.style.zIndex = "100";

    // Punta a V sotto al cerchio
    const triangle_border = document.createElement("div");
    triangle_border.style.width = "0";
    triangle_border.style.height = "0";
    triangle_border.style.position = "absolute";
    triangle_border.style.bottom = "-10px";
    triangle_border.style.borderLeft = "8px solid transparent";
    triangle_border.style.borderRight = "8px solid transparent";
    triangle_border.style.borderTop = "12px solid white"; // stesso colore del cerchio
    triangle_border.style.marginTop = "-2px"; // per avvicinarla al cerchio

    // Aggiunta al container
    container.appendChild(circle);
    container.appendChild(triangle);
    container.appendChild(triangle_border);

    return container;
  }

  static createPoiMarker(poi?: Poi) {
    const markerContent = document.createElement("div");
    markerContent.innerHTML = `
<div class="mappa_custom-marker">
  <div class="mappa_marker-scalable">
    <div class="mappa_marker mappa_marker-quadrato">
      <div class="mappa_label_number"></div>
      <div class="mappa_internal_img mappa_internal_img_quadrata"></div>
      <div class="mappa_etichetta_number"></div>
      <div class="mappa_v-marker-border"></div>
      <div class="mappa_v-marker"></div>
    </div>
  </div>
</div>
`;

    const content = markerContent.firstElementChild;
    if(poi){
      const element: any = content.querySelector('.mappa_internal_img');
      const etichetta: any = content.querySelector('.mappa_etichetta_number');
      if(poi.image){
        element.style.backgroundImage = `url(${poi.image})`;
        if(poi.label_number){
          etichetta.textContent = `${poi.label_number || ''}`;
          etichetta.style.display = 'block';
        }
      }else{
        element.style.backgroundImage = 'none';
        etichetta.style.display = 'none';
      }
    }


    return content;
  }

  spiderfyMarkers(clickX, clickY, markers) {
    const radius = 50;
    const angleStep = (2 * Math.PI) / markers.length;

    markers.forEach((marker, i) => {
      const angle = i * angleStep;
      const offsetX = Math.cos(angle) * radius;
      const offsetY = Math.sin(angle) * radius;

      const el = marker.content;
      const rect = el.getBoundingClientRect();

      const markerCenterX = rect.left + rect.width / 2;
      const markerCenterY = rect.top + rect.height / 2;

      const deltaX = markerCenterX - clickX;
      const deltaY = markerCenterY - clickY;

      const finalX = offsetX - deltaX;
      const finalY = offsetY - deltaY;

      this.drawSpiderMarker(marker, finalX, finalY, i)

    });
  }

  spiderfyMoltiMarkers(clickX, clickY, markers) {
    const baseRadius = 40;
    const radiusStep = 50;

    let currentIndex = 0;
    let level = 0;

    while (currentIndex < markers.length) {
      // Calcola quanti marker mettere nel livello corrente:
      // più grande è il raggio, più marker ci stanno senza sovrapporsi.
      const markerCount = Math.ceil((2 * Math.PI * (baseRadius + radiusStep * level)) / 40);

      const radius = baseRadius + radiusStep * level;
      const angleStep = (2 * Math.PI) / markerCount;

      for (let i = 0; i < markerCount && currentIndex < markers.length; i++) {
        const marker = markers[currentIndex];

        const angle = i * angleStep;
        const offsetX = Math.cos(angle) * radius;
        const offsetY = Math.sin(angle) * radius;

        const el = marker.content;
        const rect = el.getBoundingClientRect();

        const markerCenterX = rect.left + rect.width / 2;
        const markerCenterY = rect.top + rect.height / 2;

        const deltaX = markerCenterX - clickX;
        const deltaY = markerCenterY - clickY;

        const finalX = offsetX - deltaX;
        const finalY = offsetY - deltaY;

        this.drawSpiderMarker(marker, finalX, finalY, currentIndex);
        currentIndex++;
      }

      level++;
    }
  }

  drawSpiderMarker(marker: any, x: number, y: number, position: number){
    const content = marker.content;
    content.style.transition = 'transform 0.3s ease';
    content.style.transform = `translate(${x}px, ${y}px)`;
    marker.zIndex = 1000 + position;
    let element;
    switch(marker.type){
      case 'poi':
        element = content.querySelector(".mappa_marker");
        if (element) {
          element.style.borderColor = '#0455bf';
        }

        element = content.querySelector(".mappa_v-marker-border");
        if (element) {
          element.style.borderTopColor = '#0455bf';
        }
        break;
      case 'participant':
      default:
        element = content.querySelector(".mappa_marker");
        if (element) {
          element.style.borderColor = '#0455bf';
        }

        element = content.querySelector(".mappa_v-marker-border");
        if (element) {
          element.style.borderTopColor = '#0455bf';
        }

        const label: any = content.querySelector(".mappa_marker-label");
        if(label){
          label.style.display = 'none'
        }
        break;
    }

  }

  unspiderfyMarkers(show_popup?: boolean) {
    if(!this.markers_in_spider) return;
    this.markers_in_spider.forEach(marker => {
      const el = marker.content;

      el.style.transform = 'translate(0, 0)';
      marker.zIndex = 1;
      let element;

      switch(marker.type){
        case 'poi':
          element = el.querySelector(".mappa_marker");
          if (element) {
            element.style.borderColor = 'white';
          }

          element = el.querySelector(".mappa_v-marker-border");
          if (element) {
            element.style.borderTopColor = 'white';
          }
          break;
        case 'participant':
        default:
          element = el.querySelector(".mappa_marker");
          if (element) {
            element.style.borderColor = 'white';
          }

          element = el.querySelector(".mappa_v-marker-border");
          if (element) {
            element.style.borderTopColor = 'white';
          }

          element = el.querySelector(".mappa_marker-label");
          if(element){
            if(show_popup){
              element.style.display = 'block'
            }else{
              element.style.display = 'none';
            }
          }

          switch(marker.type){
            case 'start':
              marker.zIndex = 99;
              break;
            case 'end':
              marker.zIndex = 98;
              break;
          }
          break;
      }
    });
    this.markers_in_spider = [];
  }

}
